var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"core-uploader"},[_c('input',{ref:"fileControl",staticClass:"core-uploader--input",attrs:{"multiple":_vm.multiple,"type":"file","accept":_vm.acceptedFileTypes,"name":"file"},on:{"change":_vm.handleFilesSelected}})])}
var staticRenderFns = []

export { render, staticRenderFns }